import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
// import Select from "react-select";
import { toast } from "react-toastify";
import ClassList from "./ClassList";
import { useParams } from "react-router-dom";

function ClassForm() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");

  const { classId } = useParams();

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      createdBy: localStorage.getItem("userId"),
      name: "",
      description: "",
      organizationId: organizationId,
    },
  });

  useEffect(() => {
    if (!classId) {
      return;
    }

    const fetchClassData = async () => {
      const singleClassData = await get(
        `Class/GetClassByIdAsync?classId=${classId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // const classData = singleClassData.class;

      reset({
        ...singleClassData,
        id: classId,
        updatedBy: localStorage.getItem("userId"),
      });
    };

    fetchClassData();
  }, [classId]);

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await post("Class/AddUpdateClassAsync", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.isSuccess) {
        toast.success("Success!");
        if (!classId) {
          reset();
        }
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Class Form</h2>
        {/* <div className="ms-auto">
          <Link
            to="/organization-form"
            className="btn btn-outline-primary btn-sm"
          >
            Add New
          </Link>
        </div> */}
      </div>

      <div className="card">
        <div className="card-body">
          <form className="" onSubmit={handleSubmit(saveData)}>
            <div className="row g-3">
              <div className="col-3">
                <label className="form-label">
                  Name<span className="text-danger fs-9">*</span>
                </label>
                <input
                  {...register(`name`, {
                    required: "This field is required.",
                  })}
                  type="text"
                  className="form-control"
                  placeholder=""
                />
                {errors.name && (
                  <small className="text-danger">{errors.name.message}</small>
                )}
              </div>
              <div className="col-3">
                <label className="form-label">Description</label>
                <input
                  {...register(
                    `description`
                    //   {
                    //   required: "This field is required.",
                    // }
                  )}
                  type="text"
                  className="form-control"
                  placeholder=""
                />
                {errors.description && (
                  <small className="text-danger">
                    {errors.description.message}
                  </small>
                )}
              </div>
              <div className="col-12 mt-3">
                <button
                  className="btn btn-primary btn-sm"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Save" : "Save"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default ClassForm;
